module.exports = __webpack_public_path__ + "img/bg_v1.3c4fe571.png";